
<!DOCTYPE html>

<head>
  <meta charset="">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
  
</head>








<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>



<br><br><br>

<!--  -->
<h2 data-aos="zoom-in" data-aos-delay="300" style="color: #6ab187;text-align: center;">Document Signin</h2>
<br>
<div class="row p-2">
  
    <div  id="slide"  class="col-md-6 text-center ">
      
      <br>
      <img  style="width: 54%;height: 100%;border-radius: 20px;box-shadow: 40px 20px;" src="assets/doc.jpg">
      
    </div>
  
    <div  class="col-md-6">
  <br><br><br>
  
  <ul>
    <h6><img style="width: 30px;height:30px;" src="assets/handlogo.png"> Document-signing method lets you sign documents online.It uses an electronic signature and requires no paper, printing, scanning or faxing of your documents.</h6><br>
    <h6><img style="width: 30px;height:30px;" src="assets/handlogo.png"> Don’t schedule appointments or spend hours photocopying papers, use eSignature to automate it all.</h6>
    <br>
    <h6><img style="width: 30px;height:30px;" src="assets/handlogo.png"> eSign online & document templates allow signers to sign instantly & remotely, and our smart management system keeps you on top of all your business documentation</h6>
  </ul>
    </div>
</div>





<br><br>
<div class="row" data-aos="fade-up" data-aos-delay="300">
  <div style="padding-top: 10%;" class="col-md-6">
      <h3>
          <span class="topic">eSign Online: The Fast, Secure, and Eco-Friendly Way to Sign</span>
        </h3>
      <h5 style="padding-left: 10%;"><img style="width: 25px;height: 25px;" src="assets/check-mark.png"> &nbsp;&nbsp;&nbsp;Digitally sign documents streamlining eSign workflow.</h5>
      
      <h5 style="padding-left: 10%;"><img style="width: 25px;height: 25px;" src="assets/check-mark.png"> &nbsp;&nbsp;&nbsp;Streamline business documentation on a digital platform.</h5>
      
      <h5 style="padding-left: 10%;"><img style="width: 25px;height: 25px;" src="assets/check-mark.png"> &nbsp;&nbsp;&nbsp;Create and manage all documents online using templates.</h5>
  </div>

  <div class="col-md-6  text-center  " >
      <img style="width:70%;height: 90%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/esign.jpg">
  </div>
</div>
<br><br>

<br><br>

<div  class="row p-4" data-aos="fade-up" data-aos-delay="300"  style="background-color: #c9d9e6;" >

  <div class="col-md-3"></div>
  <div  class="col-md-3" style="background-color: #76b891;" >
        <br>
        <img style="width: 40px;height: 35px;" src="assets/checked.png">
       <br>
        <p style="align-items: center;">Industry-grade
          signature algorithms</p>
    </div>
   
    <div class="col-md-3" style="background-color: #76b891;" >
   
      <br>
      <img style="width: 40px;height: 35px;" src="assets/tax.png">
  <br>
      <p style="align-items: center;">Custom business
        templates<p>
  </div>
  <div class="col-md-3"></div>


</div>


<br><br><br>

<div class="row" data-aos="zoom-in" data-aos-delay="300"  >
  <div class="col">
      <h1 style="color: #6ab187;text-align: center;">eSign Documents: Your Signature, Your Way</h1>
      <br>
      <p style="text-align: center;">Got a specific requirement? We’ve got the eSign for you!</p>


         <br><br>
<div  class="row p-2" data-aos="fade-up" data-aos-delay="300"   >
<div class="col-md-3"></div>
  <div style="background-color: #eff8ff;"  class="col-md-3">
      <br>
      <img style="width: 70px;height: 60px;background-color: #eff8ff;" src="assets/agreement.png">
     <br><br>
      <h5>Electronic signatures</h5>
      <p style="align-items: center;">You receive an OTP on your email or phone, you enter the OTP & your document is electronically signed. Simple.</p>
  </div>

  <div style="background-color: #c9d9e6;" class="col-md-3">
        <br>
        <img style="width: 70px;height: 60px;" src="assets/document.png">
       <br><br>
        <h5 >DSC signatures</h5>
        <p style="align-items: center;">Entire documents are securely encrypted using private keys and digital signature workflow. Digital Signature Certificates (DSCs) are generated for quick verification.</p>
    </div>
<div class="col-md-3"></div>
   
  
</div>
  </div>
</div>

<br><br>

<div class="row p-2"  data-aos="fade-up" data-aos-delay="300"  >

  
  <div class="col-md-6  text-center ">
<img style="width:80%"  src="assets/sendmail.png">
  </div>

  <div style="margin-top: 10%;" class="col-md-6">
    <h3 style="color: #6ab187;">Speed Up Contract Closures by 99% With<br> Facheck E-Sign</h3>
    <p>Our eSign workflow & document management solution has helped our clients reduce TAT on contract execution from 10-20 days to less than 10 minutes. eSign online & document templates allow signers to sign instantly & remotely, and our smart management system keeps you on top of all your business documentation</p>
  </div>


</div>




<div class="row"    >
  <div class="col" data-aos="fade-up" data-aos-delay="300">
      <h1 style="color: #6ab187;text-align: center;">eSign Online: Where Features Meet the <br>Future of Signatures</h1>
      <br>


         <br><br>
<div  class="row p-3">

  <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col">
      <br>
      <img style="width: 70px;height: 60px;background-color: #eff8ff;" src="assets/agreement.png">
     <br><br>
      <h5>Unlimited eSign</h5>
      <p style="align-items: center;">eSign documents & contracts online from anywhere in the world at any time</p>
  </div>

  <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
        <img style="width: 70px;height: 60px;" src="assets/custtempl.png">
       <br><br>
        <h5 >Customizable templates</h5>
        <p style="align-items: center;">Draft legally valid documents in seconds</p>
    </div>
    <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
      <br>
      <img style="width: 70px;height: 60px;background-color: #eff8ff;" src="assets/digitalsign.png">
     <br><br>
      <h5>Multiple eSignature options</h5>
      <p style="align-items: center;">Digitally sign documents using our electronic, DSC, Aadhaar or PAN-based signatures</p>
  </div>

  <div style="background-color: #eff8ff;"  data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
        <img style="width: 70px;height: 60px;" src="assets/multiparty.png">
       <br><br>
        <h5 >Multiparty & multi location signing</h5>
        <p style="align-items: center;">Invite multiple signers to eSign online anywhere on your document using our drag-and-drop feature</p>
    </div>
    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
      <br>
      <img style="width: 70px;height: 60px;background-color: #eff8ff;" src="assets/flexiblesignin.png">
     <br><br>
      <h5>Flexible signing order</h5>
      <p style="align-items: center;">Impose parallel or sequential signing orders to make sure people sign when & how you want them to</p>
  </div>

  <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
        <img style="width: 70px;height: 60px;" src="assets/dashboard.png">
       <br><br>
        <h5>Smart dashboard with audit trail</h5>
        <p style="align-items: center;">Manage all your documents in one place & receive notifications about the status of your documents</p>
    </div>
    <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
      <br>
      <img style="width: 70px;height: 60px;background-color: #eff8ff;" src="assets/pdf.png">
     <br><br>
      <h5>PDF & Word support</h5>
      <p style="align-items: center;">Upload documents in numerous formats including pdf & docx, and get them signed online</p>
  </div>

  <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
        <img style="width: 70px;height: 50px;" src="assets/roles.png">
       <br><br>
        <h5 >User roles & approval workflows</h5>
        <p style="align-items: center;">Create your own eSign workflows & assign user roles to team-mates to take control of how your documents are signed</p>
    </div>
    <div class="col-md-3" ></div>
    <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
      <br>
      <img style="width: 70px;height: 60px;background-color: #eff8ff;" src="assets/encryption.png">
     <br><br>
      <h5>High-level encryption</h5>
      <p style="align-items: center;">Secure all your documentation with industry-grade cryptosystems & ensure signer authenticity through public key encryption</p>
  </div>

  <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
        <img style="width: 70px;height: 60px;" src="assets/stamp.png">
       <br><br>
        <h5>Digital stamping facilities</h5>
        <p style="align-items: center;">Get your documents legalized before signing them by paying stamp duty in real-time</p>
    </div>
    <div class="col-md-3" ></div>

</div>







  </div>
</div>



<br><br><br>
<div class="row"  data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">Integrate E-Sign Into Your Workflows Seamlessly</h3>
        <p style="text-align: center;">’s flexible eSign online solution can be integrated with any business’ documentation system with zero third-party assistance.</p>
        <p style="text-align: center;">Here’s what we offer.</p>
    </div>

</div>
<br><br>

<div  class="row p-2 text-center ">
  <div class="col-md-1"></div>
    <div class="col-md-2 mt-2" data-aos="fade-up" data-aos-delay="300"  >
        <div  class="card" style="height:150px" >
            <div class="card-body">
                <img style="width: 34%;height:30%" src="assets/api.png">
              
              <h5 class="card-title">API integrations</h5>
            </div>            
          </div>
    </div>

    <div class="col-md-2 mt-2" data-aos="fade-up" data-aos-delay="300"  >
      <div class="card" style="height:150px"  >
          <div class="card-body">
              <img style="width: 34%;height:28%" src="assets/sdk.png">
       
            <h5 class="card-title">Mobile <br> SDK</h5>
          </div>            
        </div>
  </div>

  <div class="col-md-2 mt-2" data-aos="fade-up" data-aos-delay="300"  >
    <div class="card" style="height:150px" >
        <div  class="card-body">

            <img style="width: 30%;height:34%" src="assets/deskmobile.png">
            
          <h5 class="card-title">Desktop & mobile </h5>
        </div>            
      </div>
</div>

<div class="col-md-2 mt-2" data-aos="fade-up" data-aos-delay="300"  >
  <div class="card" style="height:150px" >
      <div class="card-body">
          <img style="width: 34%;height:30%"  src="assets/stand.png">
        <h5 class="card-title">Standalone platform</h5>

      </div>            
    </div>
</div>

<div class="col-md-2 mt-2" data-aos="fade-up" data-aos-delay="300"  >
  <div class="card" style="height:150px" >
      <div class="card-body">
          <img style="width: 34%;height:30%"  src="assets/integrating.png">
          
        <h5 class="card-title">Widget-based integrations</h5>

      </div>            
    </div>
</div>
<div class="col-md-1"></div>


  </div>





  <br><br><br>

<div class="row" data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
        <h4 style="color: #6ab187;text-align: center;">Who Should Use Electronic Signatures?</h4>
      
        <br><br><br>
    </div>
</div>


<div class="row p-2" data-aos="fade-up" data-aos-delay="300">
    <div class="col-md-6">
        <br>
     
        <h4 style="margin-left: 20px;color: #6ab187;">Financial Institutions</h4><br>
        <p style="margin-left: 24px;">Banks, NBFCs & financial institutions handle thousands of documents including agreements, consent forms, mandate forms & sanction letters on a daily basis.Facheck’s eSignature software & eSign workflow can be integrated into any bank’s loan authorisation, cheque truncation, CRM or ERP processes to allow digital documents to be created & signed en masse and managed digitally; this reduces TAT on document execution to less than 10 minutes</p>
    </div>

    <div class="col-md-6  text-center  ">
        <img style="width: 70%;height: 90%;" src="assets/financialinstitute.png">
    </div>
</div>

<br><br><br><br>


<div class="row p-2" data-aos="fade-up" data-aos-delay="300">
 
    <div class="col-md-6  text-center ">
        <img style="width: 70%;height: 80%;margin-left: 20px;" src="assets/insurancecompany.png">
    </div>

    <div class="col-md-6">
        <br>
        <h4 style="color: #6ab187;margin-top: 40px;">Insurance companies</h4><br>
        <p>Facheck’s digital signature solution allows insurers to quickly create policy documents & eSign insurance documents using electronic signatures & an automated eSign workflow. Insurers can also use our customizable approval workflows to maintain the order of verification processes and reduce the time taken for pre-verification by nearly 99%.
          Our legally valid eSign solution also doubles up as a smart document management platform, where insurers can keep track of any policy changes or maintenance.</p>
    </div>
</div>


<br><br><br><br><br>
<div class="row p-2" data-aos="fade-up" data-aos-delay="300"   >
  <div class="col-md-6">
      <br>
   
      <h4 style="margin-left: 20px;color: #6ab187;">Vendor Contracts & Onboarding</h4><br>
      <p style="margin-left: 24px;">Businesses in the FMCG sector require speed & efficiency to maintain their bottom lines. Vendor contracts need to be created quickly, sent out to vendors & signed even quicker.

        Facheck’s eSignature solution features legally valid contract templates, automated eSign workflow & OTP-based online signatures, for businesses to rapidly churn out vendor contracts, get them signed electronically & manage all contracts in one place.</p>
  </div>

  <div class="col-md-6 text-center  ">
      <img style="width: 80%;height: 100%;" src="assets/vendormanage.png">
  </div>
</div>



<br><br><br><br>


<div class="row p-2" data-aos="fade-up" data-aos-delay="300"   >
 
    <div class="col-md-6  text-center  ">
        <img style="width: 70%;height: 75%;margin-right: 20px;margin-top: 40px;" src="assets/business.png">
    </div>

    <div class="col-md-6  ">
        <br>
        <h4 style="color: #6ab187;margin-top: 40px;">Any Business</h4><br>
        <p>All businesses generate documents as part of their operations. These could be commercial rental agreements, employee forms, loan documents, or business contracts. Once these documents are drafted, they’ve also got to be legalized & then signed.
          Facheck automates this entire documentation process for all businesses. We offer legally valid templates to create documents instantly, electronic signatures with eSign workflow to get them signed instantly, & digital stamping facilities to get them legalized in real-time.
          
          Our eSign solution helps businesses go completely paper-free, reduce documentation costs & slash TAT on document execution by nearly 99%.</p>
    </div>
</div>





<!--
 -->
  




 
